import { defineMessages } from 'react-intl';

var messages = defineMessages({
  errorLabel: {
    id: "neptune.StatusIcon.iconLabel.error"
  },
  successLabel: {
    id: "neptune.StatusIcon.iconLabel.success"
  },
  warningLabel: {
    id: "neptune.StatusIcon.iconLabel.warning"
  },
  pendingLabel: {
    id: "neptune.StatusIcon.iconLabel.pending"
  },
  informationLabel: {
    id: "neptune.StatusIcon.iconLabel.information"
  }
});

export { messages as default };
//# sourceMappingURL=StatusIcon.messages.mjs.map
